import InnerPageHero from '../InnerPageHero';
import { useContent } from '../../context/ContentContext';

export default function PlansHero() {
  const { content } = useContent();
  const d = content.plansHero;

  return (
    <InnerPageHero
      breadcrumbs={[
        { label: 'Home', href: '/' },
        { label: 'Membership Plans' },
      ]}
      title={d.title}
      titleAccent={d.titleAccent}
      titleSuffix={d.titleSuffix}
      description={d.description}
    />
  );
}
